module.exports = __webpack_public_path__ + "3dd02297ab9b5e23d0331a0580341637.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/galeriaFotos/079.jpg
// module id = 62
// module chunks = 0